<div class="top-nav-bar">
  <div class="top-nav-barmenu">
    <a routerLink="./drivers" routerLinkActive="active" translate>Drivers</a>
    <a routerLink="./vehicles" routerLinkActive="active" translate>Vehicles</a>
  </div>
</div>
<router-outlet></router-outlet>
